export var constants = {
    GENERAL: 'general',
    HOTKEYS: 'hotkeys',
    PRESETS: 'presets',
    STRATEGY: 'strategy',
    RANGE: 'range',
    EV: 'ev',
    EQUITY: 'eq',
    EQR: 'eqr',
    POSITIONS: 'positions',
    TEXT: 'text',
    CARDS: 'cards',
    TRAINER: 'trainer',
};
